// extracted by mini-css-extract-plugin
export var csatScore = "_ng-5";
export var header = "_ng-1";
export var panelWrapper = "_ng-2";
export var postPreview = "_ng-3";
export var rightContent = "_ng-0";
export var wrappingText = "_ng-4";